import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { InertiaApp } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress/src'

Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })
Vue.use(InertiaApp)
Vue.use(PortalVue)
Vue.use(VueMeta)

InertiaProgress.init()

let app = document.getElementById('app')

Vue.filter('toEUR', function (value) {
    if( value === 0 ) return '0,00'
    if (!value) return ''
    return parseFloat(value).toFixed(2).replace('.',',').replace(/\d(?=(\d{3})+\,)/g, '$&.');
})

Vue.mixin({
    methods: {
        isObject: function(object){
            return object != null && typeof object === 'object';
        },
        deepEqual: function(object1, object2){
            const keys1 = Object.keys(object1);
            const keys2 = Object.keys(object2);
            if (keys1.length !== keys2.length) {
                return false;
            }
            for (const key of keys1) {
                const val1 = object1[key];
                const val2 = object2[key];
                const areObjects = this.isObject(val1) && this.isObject(val2);
                if (
                    areObjects && !this.deepEqual(val1, val2) ||
                    !areObjects && val1 !== val2
                ) {
                return false;
                }
            }
            return true;
        }
    }
})

new Vue({
  metaInfo: {
    titleTemplate: (title) => title ? `${title} - Monospark CRM` : 'Monospark CRM'
  },
  render: h => h(InertiaApp, {
    props: {
      initialPage: JSON.parse(app.dataset.page),
      resolveComponent: name => import(`@/Pages/${name}`).then(module => module.default),
    },
  }),
}).$mount(app)
